import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Howl, Howler } from 'howler';

import * as actions from '../store/actions/churgerBuilderActions';

import themeSong from '../assets/audio/themeSong.wav';
import rockNRoll from '../assets/audio/rockAndRollMcDonalds.wav';
import FXWebm from '../assets/audio/soundFX/FX.webm';
import FXMp3 from '../assets/audio/soundFX/FX.mp3';

export default React.memo(function Sounds() {
	const dispatch = useDispatch();
	const page = useSelector((state) => state.page);
	const effectSound = useSelector((state) => state.FXPlaying);

	const [musicPlaying, setMusicPlaying] = useState(false);

	const musicSource = page === 'order' ? rockNRoll : themeSong;

	const music = useMemo(() => {
		return new Howl({
			src: [musicSource],
			html5: true,
			loop: true,
			volume: 0.7,
		});
	}, [musicSource]);

	const playStopHandler = () => {
		if (musicPlaying) {
			Howler.stop();
			setMusicPlaying(false);
		} else {
			music.play();
			setMusicPlaying(true);
		}
	};

	const pageSwitchCheck = useCallback(() => {
		if (musicPlaying) {
			if (page === 'order') {
				Howler.stop();
				music.play();
			} else {
				Howler.stop();
				music.play();
			}
		}
	}, [musicPlaying, page, music]);

	useEffect(() => {
		pageSwitchCheck();
	}, [page, pageSwitchCheck]);

	const suppressedSound = new Howl({
		src: [FXWebm, FXMp3],
		sprite: {
			bKok: [0, 507.3469387755102],
			breakingGlass: [2000, 375.0113378684805],
			catBell: [4000, 970.5895691609978],
			catMeowTheJewels: [6000, 3286.7573696145128],
			coins: [11000, 639.7052154195002],
			copSiren: [13000, 992.6530612244893],
			crunch: [15000, 308.82086167800435],
			crunchApple: [17000, 419.13832199546516],
			ericIngredients: [19000, 5426.4852607709745],
			fart: [26000, 220.58956916099604],
			hankBwa: [28000, 705.8956916099781],
			hankBwukkake: [30000, 1455.895691609978],
			hankPeriod: [33000, 463.2426303854871],
			hideyHo: [35000, 2183.8321995464867],
			jarabe: [39000, 3485.306122448982],
			marsVolta: [44000, 1566.1678004535133],
			mitch: [47000, 926.4625850340167],
			pop: [49000, 66.19047619047791],
			ripCardboard: [51000, 1147.0521541950093],
			seagulls: [54000, 1919.115646258504],
			seedsDropping: [57000, 1262.3582766439938],
			slipPaper: [60000, 308.82086167800793],
			splatDry: [62000, 330.88435374149583],
			splatMoist: [64000, 485.32879818594665],
			splatWet: [66000, 772.0408163265375],
			spongebobCredits: [68000, 1257.3469387755126],
			squirtLong: [71000, 507.3469387755125],
			squirtShort: [73000, 374.98866213151416],
			thunkHeavyBox: [75000, 463.2426303854942],
			thunkPipe: [77000, 176.48526077097415],
		},
		onplay: function () {
			Howler.volume(0.2);
		},
		onend: function () {
			Howler.volume(1.0);
		},
		volume: 2.7,
	});

	const unsuppressedSound = new Howl({
		src: [FXWebm, FXMp3],
		sprite: {
			pop: [49000, 66.19047619047791],
		},
	});

	if (effectSound === 'pop') {
		unsuppressedSound.play(effectSound);
		dispatch(actions.setFXPlaying(null));
	} else if (effectSound) {
		suppressedSound.play(effectSound);
		dispatch(actions.setFXPlaying(null));
	}

	const btnLabel = musicPlaying ? (
		<div>STFU!#&%</div>
	) : (
		<div>(; &#9835; &#9834; &#9834; &#9833; ;D</div>
	);

	return (
		<div className="btn SoundMobile" onClick={playStopHandler}>
			{btnLabel}
		</div>
	);
});
